export enum EnvType {
  DEV = "DEV",
  PROD = "PROD",
}


export interface CountryType {
  code: string;
  label: string;
}
